import React, { useState } from 'react';
import propTypes from 'prop-types';
import Header from 'components/CardShell/Header';
import DualButtons from 'components/DualButtons';
import InputWithValidation from 'components/InputWithValidation';
import { validateForm } from 'helpers/validateForm';
import styles from './styles.scss';

const ShipmentFilterExpiry = (props) => {
  const {
    title, pageTabs, cancel, gotoPage, updateState,
  } = props;

  const {
    shipmentFilterExpiryMinutes,
  } = props.formData;

  const [errors, setErrors] = useState(null);

  const expiryMinutesValid = () => {
    const expiryMinutes = parseInt(shipmentFilterExpiryMinutes, 10);

    if (expiryMinutes || expiryMinutes === 0) {
      return expiryMinutes > 0 && expiryMinutes < 1440;
    }

    return true;
  };

  const validationRules = {
    shipmentFilterExpiryMinutes: [
      {
        name: 'value',
        message: () => 'Expiry time must be between 1 and 1440 minutes',
        isValid: () => expiryMinutesValid(),
      },
    ],
  };

  const handleNextButtonClick = () => {
    const formValidation = validateForm(
      validationRules,
      {
        shipmentFilterExpiryMinutes,
      },
    );

    setErrors(formValidation);
    if (!formValidation.hasErrors) {
      gotoPage(6);
    }
  };

  return (
    <div className={styles.cardSection}>
      <div className={styles.cardSectionNav}>
        {pageTabs()}
      </div>
      <div className={styles.cardSectionInner}>
        <Header>{title}</Header>
        <p className={styles.innerContentTitle}>
          An expiry time in minutes for notifications. Should the filter be triggered more than this many minutes after the real world event, a notification will not be sent.
        </p>
        <div className={styles.inputGroup}>
          <InputWithValidation
            label="Expiry time in minutes (1-1440)"
            placeholder="Expiry time"
            type="text"
            name="shipmentFilterExpiryMinutes"
            value={shipmentFilterExpiryMinutes}
            onChange={(e) => { updateState({ shipmentFilterExpiryMinutes: e.target.value }); }}
            errors={errors}
          />
        </div>
      </div>
      <div className={styles.cardSectionButtons}>
        <DualButtons
          leftFunction={cancel}
          leftText="Cancel"
          rightFunction={handleNextButtonClick}
          rightText="Next"
          theme="rightPink"
        />
      </div>
    </div>
  );
};

ShipmentFilterExpiry.propTypes = {
  pageTabs: propTypes.func.isRequired,
  cancel: propTypes.func.isRequired,
  gotoPage: propTypes.func.isRequired,
  formData: propTypes.shape({
    shipment_filter_expiry_minutes: propTypes.number,
  }).isRequired,
};

export default ShipmentFilterExpiry;
